/**
 * Tests API Endpoints
 * All test resources are nested under /instruments/{instrumentId}/tests/...
 */
export const TESTS_ENDPOINTS = {
  /**
   * Get all tests for an instrument (paginated).
   * @method GET
   * @endpoint /instruments/{instrumentId}/tests
   */
  TESTS_BY_INSTRUMENT: (instrumentId: number) => `/instruments/${instrumentId}/tests`,

  /**
   * Get filtered (unpaged) tests for an instrument.
   * @method GET
   * @endpoint /instruments/{instrumentId}/tests/filter
   */
  TESTS_FILTER: (instrumentId: number) => `/instruments/${instrumentId}/tests/filter`,

  /**
   * Get a single test by ID.
   * @method GET
   * @endpoint /instruments/{instrumentId}/tests/{id}
   */
  TEST_BY_ID: (instrumentId: number, id: number) => `/instruments/${instrumentId}/tests/${id}`,

  /**
   * Create a new test.
   * @method POST
   * @endpoint /instruments/{instrumentId}/tests
   */
  CREATE_TEST: (instrumentId: number) => `/instruments/${instrumentId}/tests`,

  /**
   * Update an existing test.
   * @method PUT
   * @endpoint /instruments/{instrumentId}/tests/{id}
   */
  UPDATE_TEST: (instrumentId: number, id: number) => `/instruments/${instrumentId}/tests/${id}`,

  /**
   * Delete a test.
   * @method DELETE
   * @endpoint /instruments/{instrumentId}/tests/{id}
   */
  DELETE_TEST: (instrumentId: number, id: number) => `/instruments/${instrumentId}/tests/${id}`,

  /**
   * Get all mappings for a test.
   * @method GET
   * @endpoint /instruments/{instrumentId}/tests/{testId}/mappings
   */
  TEST_MAPPINGS: (instrumentId: number, testId: number) => `/instruments/${instrumentId}/tests/${testId}/mappings`,

  /**
   * Create, update, or delete a mapping by natural key (mappingKey).
   * @endpoint /instruments/{instrumentId}/tests/{testId}/mappings/{mappingKey}
   */
  TEST_MAPPING_BY_KEY: (instrumentId: number, testId: number, mappingKey: string) =>
    `/instruments/${instrumentId}/tests/${testId}/mappings/${encodeURIComponent(mappingKey)}`,

  /**
   * Get all processors for a test.
   * @method GET
   * @endpoint /instruments/{instrumentId}/tests/{testId}/processors
   */
  TEST_PROCESSORS: (instrumentId: number, testId: number) => `/instruments/${instrumentId}/tests/${testId}/processors`,

  /**
   * Create, update, or delete a processor by numeric ID.
   * @endpoint /instruments/{instrumentId}/tests/{testId}/processors/{processorId}
   */
  TEST_PROCESSOR_BY_ID: (instrumentId: number, testId: number, processorId: number) =>
    `/instruments/${instrumentId}/tests/${testId}/processors/${processorId}`,
} as const;
